// extracted by mini-css-extract-plugin
module.exports = {"displayInlineFlex":"FlexboxContainer_displayInlineFlex__hYLvc","displayFlex":"FlexboxContainer_displayFlex__O2QuQ"};